
const digest = '1c4bd4eb788b136661e62b4292dda1a967b2064cf65835e6e2752c71583e1f4d';
const classes = {"patientButton":"_patientButton_pyvbu_1","noteButton":"_noteButton_pyvbu_7","numberButton":"_numberButton_pyvbu_11"};
const css = `._patientButton_pyvbu_1 {
  min-width: auto;
  font-size: 12px;
  text-align: left;
}

._noteButton_pyvbu_7 {
  font-size: 12px;
}

._numberButton_pyvbu_11 {
  font-size: 12px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  